import React from 'react'
import { Link } from 'react-router-dom'
import peterImage from '../assets/peter-enlarge.jpg'
import './Hero.css'

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Precision Roll Forming Solutions</h1>
            <p>Complete roll forming lines and custom roll tooling manufactured to .0003" precision tolerances</p>
            
            <div className="hero-cta">
              <Link to="/products" className="cta-button">View Products</Link>
              <Link to="/about" className="cta-button secondary">Our Capabilities</Link>
            </div>
          </div>
          
          <div className="hero-image-section">
            <img src={peterImage} alt="Peter - Company Founder" className="founder-image" />
            <p className="founder-caption">Peter Miskolczi founded the company in 1956 with a vision for precision engineering excellence. Today, our commitment to innovative design and superior manufacturing quality continues to drive every project we undertake.</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero